<script lang="ts">
    import Spotlight from "../components/Spotlight.svelte";
    import User from "../components/User.svelte";
    import {userStore} from "../stores/yStore.svelte";
    const {store} = userStore();
    var users: any[] = $state([]);
    function enabled([key, value]: [string, any]) {
        if (value && value.initials && value.enabled === true) {
            console.debug(`%c ${value.initials}`, "color: white; background-color: #2274A5" , "enabled",  "uid: ", key);
            return  true;
        }
        return false;
        
    }

    store.subscribe((data) => {
        users = Object.entries(data.users)
            .map(([key, value]) => ({uid: key, ...(value as any)}));
    });

</script>

<div class="overflow-hidden w-full h-screen relative flex justify-center items-center">
    <Spotlight />
    {#each users as u(u.uid)}
        <User user={u} />
    {/each} 
</div>

<style>
    .my-box-shadow {
        box-shadow: 0 0 15px 2px var(--color-indigo-500);
    }
</style>